import React from 'react'
import CatholicHouseholdMemberQuery from "./CatholicHouseholdMemberQuery";


export const CatholicHouseholdMemberQueryBaptism = ({
                                                        ...props
                                                    }) => <CatholicHouseholdMemberQuery sacrament_type={"baptism"} {...props} />


